module.exports = __webpack_public_path__ + "84db59cc15952fd10e0ef2afabc09e76.png";